<template>
    <div
        ref="selectAddress"
        class="select-address"
        :class="{'swipe-left':selectAddressShow,'swipe-right':selectAddressHidden}"
        :style="{width:width,top:top,height:`${height}px`}"
    >
        <div
            ref="selectTitle"
            class="select-title"
        >
            <div
                v-for="(item,index) in citySelect"
                :key="index"
                class="city"
                :class="{'active-border':active==index}"
                @click="goToPage(index)"
            >{{item.name}}</div>
        </div>
        <div
            class="slider-box"
            :style="{height:`${height-titleHeight}px`}"
        >
            <Slider
                ref="sliderContainer"
                :sum="sum"
                :loop="false"
                :widthType="2"
                :offsetWidth="0"
                @scrollEnd="scrollEnd"
            >
                <div
                    class="container"
                    v-for="(items,indexs) in dataSelect"
                    :key="indexs"
                    :style="{width:width}"
                >
                    <ScrollView
                        class="scroll-view-wrapper tran"
                        :bounce="false"
                        :click='false'
                    >
                        <ul>
                            <li
                                v-for="(item,index) in items"
                                :key="index"
                                class="select-box"
                                :style="{width:width}"
                                @click="onclickSelect(item,indexs)"
                            ><span>{{item?item.name:''}}</span><span :class="{active:citySelect[indexs].id==(item?item.id:'')}"></span></li>
                        </ul>
                    </ScrollView>
                </div>
            </Slider>
        </div>

    </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import Slider from '@/components/Slider.vue';
import request from '@/util/request';
export default {
    name: 'SelectAddress',
    components: {
        ScrollView,
        Slider
    },
    data() {
        return {
            boxHeight: '100%',
            titleHeight: '100%',
            sum: 2,
            active: 0,
            citySelect: [
                {
                    name: '请选择',
                    id: ''
                }
            ],

            dataSelect: []
        };
    },
    props: {
        width: {
            type: String,
            default: '100%'
        },
        top: {
            type: String,
            default: '100%'
        },
        height: '',
        selectAddressShow: {
            type: Boolean,
            default: false
        },
        selectAddressHidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {},
    created() {},
    methods: {
        onClickDeliveryAddressHidden(value) {
            this.$emit('onClickDeliveryAddressHidden', value);
        },
        refresh() {
            this.$nextTick(() => {
                if (this.$refs && this.$refs.sliderContainer) {
                    this.$refs.sliderContainer.refresh();
                }
            });
        },
        goToPage(index) {
            this.$nextTick(() => {
                if (this.$refs && this.$refs.sliderContainer) {
                    this.$refs.sliderContainer.slider.goToPage(index);
                }
            });
        },
        scrollEnd(value) {
            this.active = value;
        },

        sliderBoxHeight() {
            this.titleHeight = $(this.$refs.selectTitle).height();
        },
        onclickSelect(item, indexs) {
            let city = {
                name: '请选择',
                id: ''
            };
            if (indexs == 0) {
                this.getCitys(indexs, item, city);
            } else if (indexs == 1) {
                this.getCountys(indexs, item, city);
            } else if (indexs == 2) {
                this.getTowns(indexs, item, city);
            } else if (indexs == 3) {
                this.citySelect.splice(indexs, 4, item);
                this.onClickDeliveryAddressHidden(this.citySelect);
            }
        },
        getData() {
            if (this.dataSelect.length === 0) {
                this.getProvinces();
            }
        },
        //获得全国所有省市接口
        getProvinces() {
            this.$loading.show();
            request.getProvinces({
                // 参数
                data: {},
                // 成功
                success: data => {
                    console.log(data);
                    if (data && data.provincesList.length) {
                        this.dataSelect.push(data.provincesList);
                    }
                    this.refresh();
                    this.$loading.hide();
                },
                // 接口失败
                afterError: () => {
                    this.$loading.hide();
                }
            });
        },
        //根据省id获取该省的所有市信息
        getCitys(indexs, value, city) {
            this.$loading.show();
            request.getCitys({
                // 参数
                data: {
                    provinceCode: value.id.toString()
                },
                // 成功
                success: data => {
                    console.log(data);
                    if (data && data.citysList.length) {
                        this.dataSelect.splice(indexs + 1, 4, data.citysList);
                        this.citySelect.splice(indexs, 4, value, city);
                        this.refresh();
                        setTimeout(() => {
                            this.goToPage(indexs + 1);
                        }, 20);
                    }
                    this.$loading.hide();
                },
                // 接口失败
                afterError: () => {
                    this.$loading.hide();
                }
            });
        },
        //根据市id获取该市的所有县信息
        getCountys(indexs, value, city) {
            this.$loading.show();
            request.getCountys({
                // 参数
                data: {
                    cityCode: value.id.toString()
                },
                // 成功
                success: data => {
                    console.log(data);
                    if (data && data.countysList.length) {
                        this.dataSelect.splice(indexs + 1, 4, data.countysList);
                        this.citySelect.splice(indexs, 4, value, city);
                        this.refresh();
                        setTimeout(() => {
                            this.goToPage(indexs + 1);
                        }, 20);
                    }
                    this.$loading.hide();
                },
                // 接口失败
                afterError: () => {
                    this.$loading.hide();
                }
            });
        },
        //根据县id获取该县的所有镇信息
        getTowns(indexs, value, city) {
            this.$loading.show();
            request.getTowns({
                // 参数
                data: {
                    countyCode: value.id.toString()
                },
                // 成功
                success: data => {
                    console.log(data);
                    if (data && data.townsList.length) {
                        this.dataSelect.splice(indexs + 1, 4, data.townsList);
                        this.citySelect.splice(indexs, 4, value, city);
                        this.refresh();
                        setTimeout(() => {
                            this.goToPage(indexs + 1);
                        }, 20);
                    } else {
                        this.dataSelect.splice(indexs + 1, 4);
                        this.citySelect.splice(indexs, 4, value);

                        this.refresh();
                        setTimeout(() => {
                            this.goToPage(indexs + 1);
                        }, 20);
                        this.citySelect.splice(indexs, 4, value);
                        this.onClickDeliveryAddressHidden(this.citySelect);
                    }
                    this.$loading.hide();
                },
                // 接口失败
                afterError: () => {
                    this.$loading.hide();
                }
            });
        }
    },

    mounted() {
        this.sliderBoxHeight();
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.select-address {
    position: absolute;
    left: 100%;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2004;
    // overflow-y: auto;
    // overflow-scrolling: touch;
    // -webkit-overflow-scrolling: touch;
    background: #ffffff;
    &.swipe-left {
        transform: translate3d(-100%, 0, 0);
        transition: transform 0.5s ease-out;
    }
    &.swipe-right {
        transform: translate3d(0, 0, 0);
        transition: transform 0.5s ease-out;
    }
    .select-title {
        box-sizing: content-box;
        height: $rem70;
        border-top: 1px solid #cccccc;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        padding-left: $rem30;
        .city {
            width: auto !important;
            line-height: $rem70;
            font-family: PingFangSC-Regular;
            font-size: $rem28;
            color: #c29451;
            text-align: center;
            margin-right: $rem40;
            &.active-border {
                border-bottom: 2px solid #c29451 !important;
            }
        }
    }
    .slider-box {
        width: 100%;
        height: 100%;
        .slider {
            height: 100% !important;
            .slider-group {
                //display: flex;
                height: 100% !important;
                overflow: auto !important;
                .slider-item {
                    height: 100% !important;
                    padding-top: $rem10;
                    // overflow: initial !important;
                    // overflow-y: scroll !important;
                    // overflow-scrolling: touch !important;
                    // -webkit-overflow-scrolling: touch !important;
                    //width: auto !important;
                    position: relative;
                    float: left;
                    .select-box {
                        font-family: PingFangSC-Regular;
                        font-size: $rem28;
                        color: #333333;
                        padding: $rem30 0 $rem30 $rem30;
                        text-align: left;
                        position: relative;
                        display: flex;
                        .active {
                            position: relative;
                            top: -$rem4;
                            left: $rem4;
                            width: $rem32;
                            height: $rem32;
                            background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/392/8/11677/897/5bcee93dEa0df55d2/b515904f911135b1.png');
                            background-repeat: no-repeat;
                            background-position: 0 0;
                            background-size: 100% 100%;
                            content: '';
                        }
                    }
                }
            }
        }
    }
}
</style>
